import { defineAction } from '~/prix'
import { z } from 'zod'
import materialRequestCreateAction from './materialRequestCreate.action.json' with { type: 'json' }
import { materialRequestItemObject, materialRequestObject } from '../materialRequestObject'

const materialRequestCreateDefinition = defineAction({
  ...materialRequestCreateAction,
  input: materialRequestObject
    .pick({
      id: true,
      citizenId: true,
      requestDate: true,
    })
    .partial({ id: true, requestDate: true })
    .extend({
      items: z
        .array(
          materialRequestItemObject
            .pick({
              id: true,
              materialId: true,
              requestedQuantity: true,
              unitMeasure: true,
            })
            .partial({ id: true, unitMeasure: true }),
        )
        .min(1),
    }),
  output: z.object({
    id: materialRequestObject.shape.id,
    protocolId: z.string().uuid(),
    protocolCode: z.number().int().positive(),
  }),
})

export default materialRequestCreateDefinition
